<template>
<div>
	<LeftSidebar :open="roomAmenitySidebarOpen" v-if="roomAmenitySidebarOpen"
		width="550" 
		:updateSidebar="updateRoomAmenitySidebarOpen"
		:class="{ 'white' : !darkTheme, 'grey darken-2' : darkTheme }" 
		:lowerTitle="true"
		dark
		:actionIcon="'help'"
        :actionFunction="showHelp"
		:toolbarColor="'indigo darken-4'"
		style="z-index: 32 !important"
		>
		
		<div slot="sbTitle" >
			{{selectedBuilding.bldgAlpha}} - {{selectedRoom.number}} Room Amenities
    	</div> 

    	<div slot="sbContent" class="caption pt-4">
    		<RoomAmenitiesSidebarContent :key="reset"/>
    	</div>	    
	</LeftSidebar>
	<HelpRoomAmenities />
</div>
</template>

<script>

import { mapMutations, mapState } from 'vuex'
import LeftSidebar from '@/components/LeftSidebar'
import RoomAmenitiesSidebarContent from './RoomAmenitiesSidebarContent'
import HelpRoomAmenities from '@/components/help/HelpRoomAmenities'

export default {

	data() {
  		return {
  			reset: 1,		// This is a hack used to reset children
  		}
	},

	components : { LeftSidebar, RoomAmenitiesSidebarContent, HelpRoomAmenities },

	watch: {
		roomAmenitySidebarOpen (val) { if (!val) { this.reset = this.reset +1 } },
	},

	computed: {

		...mapState({
			roomAmenitySidebarOpen: state => state.ui.roomAmenitySidebarOpen,
			darkTheme: 				state => state.ui.darkTheme,
			selectedBuilding: 		state => state.space.selectedBuilding,
			selectedRoom: 			state => state.space.selectedRoom,
			//userManagedDepts: state => state.user.userManagedDepts,
		}),
	},

	methods: {
	  	...mapMutations([	'updateRoomAmenitySidebarOpen',	 'setShowHelpRoomAmenities' 						]),

	  	showHelp: function () {
	  			console.log("Show Help")
                this.setShowHelpRoomAmenities(true)
            }
	}						
}

</script>


<style>
</style>





// WEBPACK FOOTER //
// src/components/roomAmenities/RoomAmenitiesSidebar.vue